// noinspection ES6UnusedImports

import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getAxiosInstance } from "../redux/common";
import { alertAdd, register_organization } from "../redux/actions";
import {
  CssBaseline,
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { makeStyles } from "@material-ui/core/styles";
import LoginForm from "./login";
import {
  BrowserRouter as Router,
  Route,
  Link as RouterLink,
  Switch,
  Redirect,
  useRouteMatch,
  useLocation,
  useParams,
  useHistory,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "../store";
import Loader from "../components/loader";
import Grid from "@material-ui/core/Grid";
import PageTitle from "../components/page-title";
import s from "./index.module.css";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Visibility } from "@material-ui/icons";
import ReCAPTCHA from "react-google-recaptcha";
import Alert from "@material-ui/lab/Alert";
import { brand } from "../theme";
import { usePasswordStrength } from "../hooks/usePasswordStrength";
import { PasswordStrengthMeter } from "../components/password-strength-meter";
import OutboundMessages from "./outbound-messages";

const OUTBOUND_MESSAGES_PATH = "/admin-panel/outbound-messages";

const OrangeButton = styled(Button)`
  background-color: ${brand.teal};
  color: white;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

/*
 function CenteredTabs(props) {
 const classes = useStyles();

 const [value, setValue] = React.useState(props.value);

 if (value != props.value) {
 setValue(props.value);
 }

 return (
 <Paper className={classes.root}>
 <Tabs
 value={value}
 indicatorColor="primary"
 textColor="primary"
 centered
 >
 <Tab component={RouterLink} label="Użytkownicy" to="/owner-panel/tenants"  />
 <Tab component={RouterLink} label="Zamówienia" to="/owner-panel/orders"  />
 </Tabs>
 </Paper>
 );
 }
 */

function CenteredTabs() {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);

  return (
    <Paper className={classes.root}>
      <Tabs value={value} indicatorColor="primary" textColor="primary" centered>
        {/* <Tab
          component={RouterLink}
          label="Użytkownicy"
          to="/admin-panel/tenants"
        /> */}
      </Tabs>
    </Paper>
  );
}

function Main(props) {
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const outboundMessagesOpen = !!useRouteMatch(OUTBOUND_MESSAGES_PATH);
  const { userState } = props;
  const [user, setUser] = userState;
  const classes = useStyles();

  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [formIsValid, setFormIsValid] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [recaptchaValid, setRecaptchaValid] = useState(true);
  const {
    score: passwordScore,
    requirements: passwordRequirements,
  } = usePasswordStrength(password);

  const [isRegisterInProgress, setIsRegisterInProgress] = useState(false);
  const [registerCompleted, setRegisterCompleted] = useState(false);

  const [organizationCreated, setOrganizationCreated] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [invalidPasswordInputChar, setInvalidPasswordInputChar] = useState(
    false
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setFormIsValid(
      name &&
        testEmailPattern(mail) &&
        password &&
        password2 &&
        passwordsMatch &&
        recaptchaValid &&
        passwordScore > 4
    );
  }, [
    name,
    mail,
    passwordsMatch,
    password,
    password2,
    recaptchaValid,
    passwordScore,
  ]);

  useEffect(() => {
    setPasswordsMatch(password === password2);
  }, [password2, password]);

  const testEmailPattern = (mail) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      mail
    );
  };

  const onChange = (value) => {
    setRecaptchaValid(!!value);
  };

  const cancel = (e) => {
    e.preventDefault();

    history.push("/login");
  };

  async function logout() {
    try {
      await getAxiosInstance().post("/api/auth/logout-owner", {});
      setUser(null);
    } catch (e) {
      console.error(e);
    }
  }

  const submit = async (e) => {
    e.preventDefault();

    if (formIsValid) {
      try {
        setIsRegisterInProgress(true);
        const response = await dispatch(
          register_organization({
            name,
            mail,
            password,
          })
        );

        if (response.status === 200) {
          setErrorMessage("");
          setOrganizationCreated(true);
          setRegisterCompleted(true);
          setName("");
          setMail("");
          setPassword("");
          setPassword2("");
          setRecaptchaValid(false);

          setTimeout(() => {
            setOrganizationCreated(false);
          }, 3000);
        } else {
          const message = response.data.message;

          if (message.indexOf("Email is not unique") !== -1) {
            setErrorMessage("Email nie jest unikalny.");
          } else if (
            message.indexOf("Organization name is not unique") !== -1
          ) {
            setErrorMessage("Nazwa organizacji nie jest unikalna");
          }
        }
        setIsRegisterInProgress(false);
      } catch (e) {
        let errorMessage;
        if (e.response.status === 409) {
          if (e.response.data.message.includes("Invalid email address")) {
            setErrorMessage(
              "Błąd rejestracji, niepoprawny format adresu email."
            );
          } else {
            setErrorMessage(
              "Błąd rejestracji, email jest już używany w systemie."
            );
          }
        } else {
          setErrorMessage(`Błąd rejestracji, (${e.message}).`);
        }

        dispatch(
          alertAdd({
            text: errorMessage,
            isError: true,
          })
        );
      }
    }
  };

  const header = (
    <>
      <div className={classes.root}>
        <AppBar position="static" style={{ backgroundColor: brand.navy }}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Panel administracyjny
            </Typography>
            <Button color="inherit" onClick={logout}>
              Wyloguj się
            </Button>
          </Toolbar>
        </AppBar>
      </div>
      <Paper square>
        <Tabs
          value={outboundMessagesOpen ? 1 : 0}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            label="Rejestracja organizacji"
            component={RouterLink}
            to="/admin-panel"
          />
          <Tab
            label="Wiadomości wychodzące"
            component={RouterLink}
            to={OUTBOUND_MESSAGES_PATH}
          />
        </Tabs>
      </Paper>
    </>
  );

  if (outboundMessagesOpen) {
    return (
      <>
        {header}
        <OutboundMessages />
      </>
    );
  }

  return (
    <>
      {header}
      {organizationCreated && <Alert>Organizacja została założona</Alert>}
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={8} md={6}>
          <Box p={1}>
            <Button size="small" variant="contained">
              Pobierz logi
            </Button>
          </Box>
          <Box p={1}>
            <PageTitle title={`Rejestracja organizacji`} />
            <form onSubmit={submit} noValidate autoComplete="off">
              <Box mt={1}>
                <TextField
                  label="Imię i nazwisko"
                  variant="outlined"
                  value={name}
                  required
                  fullWidth
                  onChange={(e) => setName(e.target.value)}
                />
              </Box>

              <Box mt={1}>
                <TextField
                  error={!(mail === "" || testEmailPattern(mail))}
                  helperText={
                    !(mail === "" || testEmailPattern(mail)) &&
                    "Nieprawidłowy adres email"
                  }
                  label={"Email właściciela"}
                  variant="outlined"
                  required
                  value={mail}
                  fullWidth
                  onChange={(e) => setMail(e.target.value)}
                />
              </Box>
              <Box mt={1} display="flex">
                <TextField
                  label="Hasło"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  error={invalidPasswordInputChar}
                  helperText={
                    invalidPasswordInputChar ? "Spacja nie jest dozwolona." : ""
                  }
                  required
                  onChange={(e) => {
                    if (e.target.value.includes(" ")) {
                      setInvalidPasswordInputChar(true);
                      setTimeout(
                        () => setInvalidPasswordInputChar(false),
                        3000
                      );
                    } else {
                      setInvalidPasswordInputChar(false);
                    }
                    setPassword(e.target.value.split(" ").join(""));
                  }}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label="toggle password visibility"
                        >
                          <Visibility />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  error={password2 && !passwordsMatch}
                  helperText={
                    password2 && !passwordsMatch
                      ? "Powtórzone hasło nie jest zgodne"
                      : ""
                  }
                  label="Powtórz hasło"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  value={password2}
                  required
                  onChange={(e) =>
                    setPassword2(e.target.value.split(" ").join(""))
                  }
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          aria-label="toggle password visibility"
                        >
                          <Visibility />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box mt={1}>
                <span className={s.formHint}>* Pola wymagane</span>
              </Box>
              <PasswordStrengthMeter
                score={passwordScore}
                requirements={passwordRequirements}
              />

              {process.env.REACT_APP_RECAPTCHA_SITEKEY && (
                <Box mt={1}>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY}
                    onChange={onChange}
                  />
                </Box>
              )}
              <Box mt={1} display="flex">
                <OrangeButton
                  type="submit"
                  variant={"contained"}
                  disabled={!formIsValid}
                >
                  Zarejestruj organizację
                </OrangeButton>
              </Box>
            </form>
          </Box>
        </Grid>
      </Grid>
      {/* <CenteredTabs /> */}
    </>
  );
}

function Protected(props) {
  const { userState } = props;
  const [user, setUser] = userState;
  const location = useLocation();

  async function checkLogin() {
    if (user === undefined) {
      try {
        const authResult = await getAxiosInstance().get(
          "/api/auth/check-owner"
        );
        setUser(authResult.data);
      } catch (e) {
        setUser(null);
      }
    }
  }

  useEffect(() => {
    checkLogin();
  });

  if (user === undefined) {
    return <Loader loading={true} text="Uwierzytelnianie" />;
  } else if (user === null) {
    // Remember the deep link so the login form can send the user back to it.
    return (
      <Redirect
        to={{ pathname: "/admin-panel/login", state: { from: location } }}
      />
    );
  } else {
    return <Main userState={userState} />;
  }
}

function SuperAdminApp() {
  const userState = useState();
  const [user, setUser] = userState;

  return (
    <>
      <CssBaseline />
      <Router>
        <Switch>
          <Route exact path="/admin-panel/login">
            <LoginForm onUserChange={setUser} />
          </Route>
          <Provider store={store}>
            <Route path="/admin-panel">
              <Protected userState={userState} />
            </Route>
          </Provider>
        </Switch>
      </Router>
    </>
  );
}

export default SuperAdminApp;
